import { gql } from "@apollo/client";

export const QUERY_GET_COUNTRIES = gql`
  query QUERY_GET_COUNTRIES {
    country(order_by: { phonecode: asc }) {
      id
      phonecode
      name
      sortname
    }
  }
`;

export const QUERY_GET_COUNTRIES_ORDER_NAME = gql`
  query QUERY_GET_COUNTRIES {
    country(order_by: { name: asc }) {
      id
      phonecode
      name
      sortname
    }
  }
`;

export const QUERY_GET_COUNTRIES_ORDER_PHONECODE = gql`
  query QUERY_GET_COUNTRIES {
    country(order_by: { phonecode: asc }) {
      id
      phonecode
      name
      sortname
    }
  }
`;

export const QUERY_GET_STATES_ORDER_NAME = gql`
  query QUERY_GET_STATES($countryId: Int!) {
    state(where: { countryId: { _eq: $countryId } }, order_by: { name: asc }) {
      id
      name
      countryId
    }
  }
`;
  

export const QUERY_GET_CITIES_ORDER_NAME = gql`
  query QUERY_GET_CITIES($stateId: Int!) {
    city(where: { stateId: { _eq: $stateId } }, order_by: { name: asc }) {
      id
      name
      stateId
    }
  }
`;